import { Link, useLocation } from 'react-router-dom';
import { Home, Search, PlusCircle, MessageCircle, User } from 'lucide-react';

export default function MobileNav() {
  const location = useLocation();
  
  const links = [
    { to: '/', icon: Home, label: 'Inicio' },
    { to: '/products', icon: Search, label: 'Buscar' },
    { to: '/wants/new', icon: PlusCircle, label: 'Publicar' },
    { to: '/wants-chat', icon: MessageCircle, label: 'Chat' },
    { to: '/profile', icon: User, label: 'Perfil' }
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t z-40">
      <div className="flex justify-around items-center h-16">
        {links.map(({ to, icon: Icon, label }) => (
          <Link
            key={to}
            to={to}
            className={`flex flex-col items-center justify-center w-16 h-full transition ${
              location.pathname.startsWith(to) ? 'text-primary' : 'text-gray-500'
            }`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-xs mt-1">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}